import styled, { css, keyframes } from 'styled-components';

import { TransientProps } from '@common/types';

const carouselFadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.97);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const Container = styled.div`
  width: calc(100% + 2.5rem);
  margin: -1.25rem -1.25rem 0;
  overflow: hidden;
`;

export const CarouselTrack = styled.div`
  position: relative;
  overflow: hidden;
`;

type SlideProps = TransientProps<{ active: boolean }>;

export const Slide = styled.div<SlideProps>`
  ${({ $active: isActive }) => css`
    display: ${isActive ? 'block' : 'none'};
    animation: ${isActive ? carouselFadeIn : 'none'} 0.4s ease-out;
    cursor: pointer;

    img {
      width: 100%;
      height: 360px;
      display: block;
      object-fit: cover;
    }

    a {
      display: block;

      img {
        width: 100%;
        height: 360px;
        display: block;
        object-fit: cover;
      }
    }
  `}
`;

export const DotsContainer = styled.div`
  position: absolute;
  bottom: 0.625rem;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  z-index: 2;
`;

type DotProps = TransientProps<{ active: boolean }>;

export const Dot = styled.button<DotProps>`
  ${({ theme, $active: isActive }) => css`
    height: 0.5rem;
    border-radius: ${isActive ? '4px' : '50%'};
    border: none;
    width: ${isActive ? '1.5rem' : '0.5rem'};
    background: ${isActive
      ? theme.colors.brand.primary.default
      : theme.colors.base.border};
    cursor: pointer;
    transition: ${theme.transition.default};
    padding: 0;

    :hover:not(:disabled) {
      background: ${isActive
        ? theme.colors.brand.primary.default
        : theme.colors.foreground[40]};
    }
  `}
`;
